export default __webpack_public_path__ + "static/media/DR.LENTE_Logo.92a944e1.svg";